/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RealtimeKitParticipantTokenEntity } from '../models/RealtimeKitParticipantTokenEntity';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MeetingCustomerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Mint RealtimeKit join token for a booked customer
     * Requires an active fulfilled booking on this meeting or its course group. The host must start the session first.
     * @param meetingId
     * @returns RealtimeKitParticipantTokenEntity
     * @throws ApiError
     */
    public meetingCustomerControllerCreateRealtimeKitParticipantTokenV1(
        meetingId: string,
    ): CancelablePromise<RealtimeKitParticipantTokenEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/customer/meeting/{meetingId}/realtime-kit/participant-token',
            path: {
                'meetingId': meetingId,
            },
        });
    }
}
